import { render, staticRenderFns } from "./BracketBoard.vue?vue&type=template&id=2ddc2f30&scoped=true&"
import script from "./BracketBoard.vue?vue&type=script&lang=js&"
export * from "./BracketBoard.vue?vue&type=script&lang=js&"
import style0 from "./BracketBoard.vue?vue&type=style&index=0&id=2ddc2f30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc2f30",
  null
  
)

export default component.exports